import { Suspense, lazy } from 'react';

const UserProfile = lazy(() => import('../components/UserProfile'));

const UserProfileLazy: React.FC = () => {
    return <Suspense><UserProfile/></Suspense>;
}

export default UserProfileLazy;